import classNames from "classnames";
import { PhosphorCheck, PhosphorHourglass, type PhosphorIconProps, PhosphorStack, PhosphorX } from "components/Atoms/PhosphorIcon";
import React from "react";

export interface RowIcon {
  icon: (props: PhosphorIconProps) => JSX.Element
  className: string
}

export const phaseIcons: Record<server.dto.AdvancingFormItemPhases, RowIcon> = {
  unknown: { icon: PhosphorHourglass, className: "unknown" },
  pending: { icon: PhosphorStack, className: "pending" },
  approved: { icon: PhosphorCheck, className: "approved" },
  declined: { icon: PhosphorX, className: "declined" },
};

export const AdvancingRowIcon = ({ rowIcon }: { rowIcon: RowIcon }) =>
  <div className={classNames("advancing-row-icon", rowIcon.className)}><rowIcon.icon iconSize="small" /></div>;
